// src/app/services/item-details-handler.service.ts
import { inject, Injectable } from '@angular/core';
import { DetailsService } from 'src/app/pages/new-details/new-details.service';
import { CustomRouteService } from 'src/app/pages/custom-route/services';
import { detailsAdapter } from 'src/app/pages/new-details/new-details.adapter';
import { catchError, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

export type ItemType = 'point' | 'event';
export interface ItemPayload {
  element_id: string;
  type: ItemType;
  operation_id?: string;
  completion_id?: string;
}

export interface ItemDetailsResult {
  is_successful: boolean;
  reason?: string;
}

@Injectable({ providedIn: 'root' })

export class ShowItemDetailsService {
  private _customRouteService = inject(CustomRouteService);
  private _detailsService = inject(DetailsService); 
  private _router = inject(Router);
  
  show(item: ItemPayload) {
    if (!item?.element_id) 
      return of<ItemDetailsResult>({ is_successful: false, reason: 'No se ha especificado id del elemento' });
    
    if (!['point', 'event'].includes(item.type)) 
      return of<ItemDetailsResult>({ is_successful: false, reason: 'Tipo debe ser "point" o "event"' });

    const foundItem = this.getItemFromRoute({id: item?.element_id, type: item?.type});
    if (!foundItem?.from && !foundItem.point)
      return of<ItemDetailsResult>({ is_successful: false, reason: 'No se ha encontrado el elemento en la ruta' });

    console.log("TOOLS-DETAILS-FOUNDITEM: ", foundItem);

    const req$ = item.type === 'point'
      ? this._detailsService.getPointDetails(item.element_id)
      : this._detailsService.getEventDetails(item.element_id);

    return req$.pipe(
      map(resp => detailsAdapter(resp)),
      tap(async adapted => {
        if (item.type === 'point') 
            this._detailsService.setPointData(adapted);
        else 
            this._detailsService.setEventData(adapted);

        const typeNormalized = item.type === 'event' ? 'event' : 'point';
        if (foundItem.from && foundItem.point){
          this._router.navigate(
            ['/home', typeNormalized, foundItem.from.id],
            {
                queryParams: {
                    from: 'saturated',
                    pointId: foundItem.point?.id,
                    pointType: foundItem.point?.type
                }
            }
          );
        }
        else{
          this._router.navigate(['/home', typeNormalized, item.element_id]);
        }

        // if (this._breakpointsService.isMobile())
        //   await this._indicatorsService.openBottomSheetDetailsMobile(Number(item.element_id), item.type);
        // else 
        //   await this._indicatorsService.openBottomSheetDetailsDesktop(Number(item.element_id), item.type);

      }),
      map(() => ({ is_successful: true } as ItemDetailsResult)),
      catchError(() => of({ 
        is_successful: false, 
        reason: 'No se ha encontrado el punto o evento' 
      }))
    );
  }

    public getItemFromRoute(item){
      if (!item.id || !item.type)
        return { point: null, from: null };

      // const item = { id: 108, type: 'point' }; //related
      // const item = { id: 107, type: 'point' }; //point
      const dailyRoutes = this._customRouteService.customRouteData()?.dailyRoutes;

      const foundPointFrom = dailyRoutes?.flatMap(day => day.points ?? [])?.find(point => point.id === item.id);
      console.log("DEBUGHERE: foundPointFrom; ", foundPointFrom);

      const foundRelatedTo = dailyRoutes
          ?.flatMap(day => day.points ?? [])
          .flatMap(point =>
              (point.relatedsItems ?? [])
                  .map(related => ({ point: {id: point.id, type: point.type}, related: {id: related.id, type: related.type} }))
          )
          .find(({ related }) => related.id === Number(item.id));

      console.log("DEBUGHERE: foundRelatedTo; ", foundRelatedTo);

      return {
          point: foundPointFrom ? {id: foundPointFrom.id, type: foundPointFrom.type} : (foundRelatedTo?.point ? {id: foundRelatedTo.point.id, type: foundRelatedTo.point.type} : null) ,
          from: foundRelatedTo?.related ? {id: foundRelatedTo.related.id, type: foundRelatedTo.related.type} : null,
      };

  }
}